
import { Vue } from "vue-class-component";
import { flamegraph } from "d3-flame-graph";
import * as d3 from "d3";
import { store } from "@/store"; //引入仓库
import {
  dispatchPerfettoStackSearch,
  dispatchPerfettoStackSearchFuncitons,
  dispatchPerfettoStackSearchSo,
  dispatchPerfettoReport,
  dispatchPerfettoSoList,
  dispatchXcodeSoList,
  dispatchPerfettoStackSearchV2,
  dispatchXcodeStack,
} from "@/store/performance/actions";
import {
  readGetPerfettoStack,
  readGetPerfettoStackSearch,
  readGetPerfettoStackSearchFunctions,
  readGetPerfettoStackSearchSo,
  readGetPerfettoReport,
  readGetPerfettoSoList,
  readGetPerfettoStackSearchV2,
  readGetXcodeStack,
} from "@/store/performance/getters"; //引入仓库接口
import axios from 'axios'

export default class Test extends Vue {
  /* ios内存堆栈对比 */
    stack_show = false;
    stackV2Data = {
      decrease: {children: []},
      increase: {children: []},
      tree: {
        children: []
      },
    }
    merge_show = null

    renderStackV2() {
      const chart = flamegraph().width(1200).inverted(true)
      const data = {
        "name": "root",
        "value": 100,
        "children": [
          {
            "name": "root",
            "value": 30,
            "children": [
              {
                "name": "subFunctionA1",
                "value": 10
              },
              {
                "name": "subFunctionA2",
                "value": 20
              }
            ]
          },
          {
            "name": "root",
            //"value": 70
          },
          {
            "name": "root",
            //"value": 70
          },
        ]
      }

      d3.select("#merge")
        .datum(data)
        .call(chart)
    }

    addValueField2(data) {
      if (data) {
        if (data?.Name == "root") {
          data.name = data?.Name +
            " " +
            (data?.MallocSize / 1024 / 1024).toFixed(2) +
            "MB";
          data.value = data?.MallocSize
        } else {
          data.name = data.Name
          data.value = data.MallocSize
        }

        if (Array.isArray(data.children)) {
          data.children.forEach((child) => {
            this.addValueField2(child);
          });
        }
      }
    }

    get ios_perfettoStack_v2() {
      let obj = JSON.parse(JSON.stringify(this.stackV2Data));
      if (
        this.stackV2Data?.tree?.children?.length == 0 ||
        JSON.stringify(obj.tree) === "{}"
      ) {
        console.log("-");
      } else {
        this.addValueField2(obj?.tree);
      }
      if (
        this.stackV2Data?.increase?.children?.length == 0 ||
        JSON.stringify(obj.increase) === "{}"
      ) {
        console.log("-");
      } else {
        this.addValueField2(obj?.increase);
      }
      if (
        this.stackV2Data?.decrease?.children?.length == 0 ||
        JSON.stringify(obj.decrease) === "{}"
      ) {
        console.log("-");
      } else {
        this.addValueField2(obj?.decrease);
      }

      return obj;
    }

    public labelTime2 = (d, data) => {
      return (
        d.data.name +
        "\nLibraryName: " +
        d.data.LibraryName +
        "\nMallocSize: " +
        this.getNum(d.data.value) +
        (d.data.MallocSizeDiff ? this.diffNum(d.data.MallocSizeDiff) : "") +
        "\nCount: " + d.data.Count
      );
    };

    public iosWallTime_v2 = (d, originalColor, colorMapper) => {
      // 使用 colorMapper 计算颜色
      const color = colorMapper(d.data.value);

      // 如果没有输入，直接返回计算出的颜色
      if (
        this.funcList === "" &&
        this.so_list.length == 0
      ) {
        return color;
      } else {
        // 如果输入存在，根据输入内容判断是否需要修改颜色
        if (this.funcList) {
          let list = [this.funcList];
          // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
          const hasMatchingKeyword = list.some((v) => {
            return (
              d.data.Name.toUpperCase().indexOf(v.toUpperCase()) !== -1
            );
          });

          // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
          return hasMatchingKeyword ? "#f00" : color;
        }
        if (this.so_list.length > 0) {
          const hasMatchingKeyword = this.so_list.some((v) => {
            return d.data.LibraryName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
          });

          // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色

          return hasMatchingKeyword ? "#f00" : color;
        }
      }
    };

    renderIos_v2_merge(selector, data) {
      let flame: any = flamegraph();
      function getAllValues(node) {
        const values = [node.value];
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => {
            values.push(...getAllValues(child));
          });
        }
        return values;
      }
      let color_list = [];

      color_list = ["#B6EBCF  ", "#FEBEBE", "#DAC4FF"];

      // 获取火焰图数据中的最大值
      const treeRootValue = this.ios_perfettoStack_v2?.tree.MallocSize;
      const decreaseRootValue = this.ios_perfettoStack_v2?.decrease.MallocSize;
      const increaseRootValue = this.ios_perfettoStack_v2?.increase.MallocSize;
      const treeColorMapper = d3
        .scaleLinear()
        .domain([0, treeRootValue * 0.5, treeRootValue])
        .range(["#B6EBCF", "#FEBEBE", "#DAC4FF"]);

      const decreaseColorMapper = d3
        .scaleLinear()
        .domain([0, decreaseRootValue * 0.5, decreaseRootValue])
        .range(["#6EC3FF", "#FFD15C", "#FF6A5C"]);

      const increaseColorMapper = d3
        .scaleLinear()
        .domain([0, increaseRootValue * 0.5, increaseRootValue])
        .range(["#6EC3FF", "#FFD15C", "#4CAF50"]);

      flame
        .width(window.innerWidth - 20)
        .label((d) => this.labelTime2(d, data))
        .transitionDuration(1000)
        .setColorMapper((d, originalColor) => {
          let colorMapper;
          if (d.data.type === "public") {
            colorMapper = treeColorMapper;
          } else if (d.data.type === "decrease") {
            colorMapper = decreaseColorMapper;
          } else if (d.data.type === "increase") {
            colorMapper = increaseColorMapper;
          } else if (d.data.type === "merge") {
            colorMapper = () => "gray";
          } else {
            colorMapper = () => 'rgb(208, 235, 215)';
          }

          return this.iosWallTime_v2(d, originalColor, colorMapper);
        })
        .inverted(true);

      d3.select(selector).datum(data).call(flame)
    }

    renderFlame_v2(selector, data) {
      let flame: any = flamegraph();
      function getAllValues(node) {
        const values = [node.value];
        if (Array.isArray(node.children)) {
          node.children.forEach((child) => {
            values.push(...getAllValues(child));
          });
        }
        return values;
      }
      let color_list = [];
      if (selector == "#tree") {
        color_list = ["#B6EBCF  ", "#FEBEBE", "#DAC4FF"];
      } else if (selector == "#decrease") {
        color_list = ["#6EC3FF", "#FFD15C", "#FF6A5C"];
      } else if (selector == "#increase") {
        color_list = ["#6EC3FF", "#FFD15C", "#4CAF50"];
      }
      // 获取火焰图数据中的最大值
      const allValues = getAllValues(data);
      function getMaxValueByType(data, type) {
        return d3.max(getAllValues(data).filter((d) => d.type === type));
      }
      const maxTreeValue = getMaxValueByType(data, "public");
      const maxDecreaseValue = getMaxValueByType(data, "decrease");
      const maxIncreaseValue = getMaxValueByType(data, "increase");
      const decreaseColorMapper = d3
        .scaleLinear()
        .domain([0, maxDecreaseValue * 0.5, maxDecreaseValue])
        .range(["#6EC3FF", "#FFD15C", "#FF6A5C"]);

      const increaseColorMapper = d3
        .scaleLinear()
        .domain([0, maxIncreaseValue * 0.5, maxIncreaseValue])
        .range(["#6EC3FF", "#FFD15C", "#4CAF50"]);
      const treeColorMapper = d3
        .scaleLinear()
        .domain([0, maxTreeValue * 0.5, maxTreeValue])
        .range(["#B6EBCF", "#FEBEBE", "#DAC4FF"]);
      const maxDataValue = d3.max(allValues);

      // 创建颜色映射器
      const colorMapper = d3
        .scaleLinear()
        .domain([0, maxDataValue * 0.5, maxDataValue])
        .range(color_list);
      flame
        .width(400)
        .label((d) => this.labelTime(d, data))
        // .tooltip({ show: this.customTooltip })
        .transitionDuration(1000)
        // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
        .setColorMapper((d, originalColor) => {
          let color;
          if (d.data.type === "public") {
            color = treeColorMapper(d.data.value);
          } else if (d.data.type === "decrease") {
            color = decreaseColorMapper(d.data.value);
          } else if (d.data.type === "increase") {
            color = increaseColorMapper(d.data.value);
          }
          return this.iosWallTime_v2(d, originalColor, color);
        })
        .inverted(true);
      // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

      // .inverted(true);

      // flame.onHover((node) => {
      //   this.func_name = node.data.name;
      //   this.func_rate = node.data.rate + "%";
      // });

      d3.select(selector).datum(data).call(flame);
      // d3.select(selector).style("background-color", "#333");
    }

    async ios_stack_v2_api() {
      const {old_date_stack, old_version_stack, size, so, func, old_date, old_version, is_all, dimension, option} = this.$route.query

      // this.old_date_stack = old_date_stack
      // this.old_version_stack = old_version_stack

      const params:any = {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        size: this.size,
        so: this.so_list.join(';'),
        func: this.funcList,
        old_date,
        old_version,
        type: is_all,
        dimension,
        option,
      }

      const {data} = await axios('xcode/xcode_stack_v2/', {params})
      this.stackV2Data = data

      let merge_stack = {
        children: [
          this.ios_perfettoStack_v2?.increase,
          this.ios_perfettoStack_v2?.tree,
          this.ios_perfettoStack_v2?.decrease,
        ],
        Name: "root",
        MallocSize: this.ios_perfettoStack_v2?.increase.MallocSize + this.ios_perfettoStack_v2?.decrease.MallocSize + this.ios_perfettoStack_v2.tree.MallocSize,
        type: "merge",
      };
      this.addValueField2(merge_stack);

      if (
        JSON.stringify(this.ios_perfettoStack_v2?.increase) == "{}" &&
        JSON.stringify(this.ios_perfettoStack_v2?.decrease) === "{}" &&
        JSON.stringify(this.ios_perfettoStack_v2?.tree) === "{}"
      ) {
        this.merge_show = false;
      } else {
        this.merge_show = true;
      }
      this.$nextTick(() => {
        if (this.merge_show) {
          this.renderIos_v2_merge("#merge", merge_stack);
        }
      });
      //this.flameLoadingStack = false;
    }
  /**/

  public height = "100%";
  public graph: any = "";
  public changeView: any = false;
  public changeViewSo: any = false;
  public scene: any = "";
  public level: any = "";
  public funcList: any = "";
  public device_id: any = "";
  public old_date_name: any = "";
  public date: any = "";
  public version: any = "";
  public report_type: any = "";
  public type: any = "";
  public localProject: any = "";
  public old_date_stack: any = "";
  public old_version_stack: any = "";
  public so: any = [];
  public changeViewMemory: any = false;
  public size: any = "";
  public so_list: any = [];
  public so_list_data = [];
  public flameLoadingStack = false;

  public so_list_data_store() {
    if (this.level) {
      console.log(readGetPerfettoReport(store));
      this.so_list_data = readGetPerfettoReport(store)?.so_list[this.scene][
        this.level
      ];
    }

    return this.so_list_data;
  }
  public async stack_v2_api() {
    this.flameLoadingStack = true;
    this.funcList = this.$route.query.func;
    if (typeof this.$route.query.so === "string") {
      this.so_list = this.$route.query.so
        ? (this.$route.query.so as any).split(",")
        : [];
    } else {
      this.so_list = this.$route.query.so;
    }

    console.log(this.so_list);
    this.size = this.$route.query.size;
    this.old_date_stack = this.$route.query.old_date_stack;
    this.old_version_stack = this.$route.query.old_version_stack;
    await dispatchPerfettoSoList(store, {
      project: this.localProject,
      level: this.level,
      device_id: Number(this.device_id),
      date: this.date,
      version: this.version,
      scene_id: this.scene,
      report_type: this.report_type,
      is_all: this.is_all,
    });
    this.funcSoTrend_data();
    await dispatchPerfettoStackSearchV2(store, {
      project: this.localProject,
      level: this.level,
      date: this.date,
      version: this.version,
      device_id: this.device_id,
      report_type: this.report_type,
      scene_name: this.scene,
      size: this.size,
      so: this.so_list.join(";"),
      func: this.funcList,
      old_date: this.old_date_stack,
      old_version: this.old_version_stack,
      is_all: this.is_all,
    });

    let merge_stack = {
      children: [
        this.perfettoStack_v2?.increase,
        this.perfettoStack_v2?.tree,
        this.perfettoStack_v2?.decrease,
      ],
      functionName: "root",
      soName: "root",
      sourceFileName: "root",
      total:
        this.perfettoStack_v2?.increase.total +
        this.perfettoStack_v2?.decrease.total +
        this.perfettoStack_v2.tree.total,
      self:
        this.perfettoStack_v2?.increase.self +
        this.perfettoStack_v2?.decrease.self +
        this.perfettoStack_v2.tree.self,
      type: "merge",
    };
    this.addValueField(merge_stack);
    this.$nextTick(() => {
      this.renderFlame_v2_merge("#merge", merge_stack);
    });
    window.addEventListener("resize", () => {
      this.renderFlame_v2_merge("#merge", merge_stack);
    });
    this.flameLoadingStack = false;
  }
  public renderFlame_v2_merge(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }
    let color_list = [];

    color_list = ["#B6EBCF  ", "#FEBEBE", "#DAC4FF"];

    // 获取火焰图数据中的最大值
    const treeRootValue = this.perfettoStack_v2?.tree.self;
    const decreaseRootValue = this.perfettoStack_v2?.decrease.self;
    const increaseRootValue = this.perfettoStack_v2?.increase.self;
    const treeColorMapper = d3
      .scaleLinear()
      .domain([0, treeRootValue * 0.5, treeRootValue])
      .range(["#B6EBCF", "#FEBEBE", "#DAC4FF"]);
    console.log(treeColorMapper);
    const decreaseColorMapper = d3
      .scaleLinear()
      .domain([0, decreaseRootValue * 0.5, decreaseRootValue])
      .range(["#6EC3FF", "#FFD15C", "#FF6A5C"]);

    const increaseColorMapper = d3
      .scaleLinear()
      .domain([0, increaseRootValue * 0.5, increaseRootValue])
      .range(["#6EC3FF", "#FFD15C", "#4CAF50"]);

    // 创建颜色映射器
    // const colorMapper = d3
    //   .scaleLinear()
    //   .domain([0, maxDataValue * 0.5, maxDataValue])
    //   .range(color_list);
    flame
      .width(window.innerWidth - 20)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) => {
        let colorMapper;
        if (d.data.type === "public") {
          colorMapper = treeColorMapper;
        } else if (d.data.type === "decrease") {
          colorMapper = decreaseColorMapper;
        } else if (d.data.type === "increase") {
          colorMapper = increaseColorMapper;
        } else if (d.data.type === "merge") {
          colorMapper = () => "gray";
        }

        // 调用 labelWallTime_v2 函数
        return this.labelWallTime_v2(d, originalColor, colorMapper);
      })
      .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public get perfettoStack_v2() {
    let obj = JSON.parse(JSON.stringify(readGetPerfettoStackSearchV2(store)));
    if (
      readGetPerfettoStackSearchV2(store)?.tree?.children?.length == 0 ||
      JSON.stringify(obj.tree) === "{}"
    ) {
      console.log("-");
    } else {
      this.addValueField(obj?.tree);
    }
    if (
      readGetPerfettoStackSearchV2(store)?.increase?.children?.length == 0 ||
      JSON.stringify(obj.increase) === "{}"
    ) {
      console.log("-");
    } else {
      this.addValueField(obj?.increase);
    }
    if (
      readGetPerfettoStackSearchV2(store)?.decrease?.children?.length == 0 ||
      JSON.stringify(obj.decrease) === "{}"
    ) {
      console.log("-");
    } else {
      this.addValueField(obj?.decrease);
    }

    return obj;
  }
  public async confirm() {
    if (this.type == "func") {
      await dispatchPerfettoStackSearchFuncitons(store, {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        func: this.funcList,
      });
      this.$nextTick(() => {
        this.renderFlame_functions(
          "#chart_funcitons",
          this.perfettoStack_functions
        );
      });
    }
    if (this.type == "so") {
      await dispatchPerfettoStackSearchSo(store, {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        so: this.so,
      });
      this.$nextTick(() => {
        this.renderFlame_so("#chart_so", this.perfettoStack_so);
      });
    }
    if (this.type == "memory") {
      await dispatchPerfettoStackSearch(store, {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        size: this.size,
        so: this.so_list,
        func: this.funcList,
      });

      this.$nextTick(() => {
        this.renderFlame("#chart", this.perfettoStackSearch);
      });
    }
    if (this.type == "memory_xcode") {
      this.flameLoading = true;
      await dispatchXcodeStack(store, {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        size: this.size,
        so: this.so_list,
        func: this.funcList,
        type: this.is_all,
        dimension: this.dimension,
        option: this.option_memory,
      });

      this.$nextTick(() => {
        this.renderFlameXcode("#chart", this.perfettoStackXcode);
        this.flameLoading = false;
      });
    }
    if (this.type == "merge") {
      await dispatchPerfettoStackSearchV2(store, {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        size: this.size,
        so: this.so_list.join(";"),
        func: this.funcList,
        old_date: this.old_date_stack,
        old_version: this.old_version_stack,
        is_all: this.is_all,
      });

      let merge_stack = {
        children: [
          this.perfettoStack_v2?.increase,
          this.perfettoStack_v2?.tree,
          this.perfettoStack_v2?.decrease,
        ],
        functionName: "root",
        soName: "root",
        sourceFileName: "root",
        total:
          this.perfettoStack_v2?.increase.total +
          this.perfettoStack_v2?.decrease.total +
          this.perfettoStack_v2.tree.total,
        self:
          this.perfettoStack_v2?.increase.self +
          this.perfettoStack_v2?.decrease.self +
          this.perfettoStack_v2.tree.self,
        type: "merge",
      };
      this.addValueField(merge_stack);
      this.$nextTick(() => {
        this.renderFlame_v2_merge("#merge", merge_stack);
      });
      window.addEventListener("resize", () => {
        this.renderFlame_v2_merge("#merge", merge_stack);
      });
    }

    if (this.type == 'ios-merge') {
      this.ios_stack_v2_api()
    }
  }
  public check_view_so() {
    this.changeViewSo = !this.changeViewSo;
    this.$nextTick(() => {
      this.renderFlame_so("#chart_so", this.perfettoStack_so);
    });
  }
  public get perfettoStack_functions() {
    let obj = JSON.parse(
      JSON.stringify(readGetPerfettoStackSearchFunctions(store))
    );
    if (
      readGetPerfettoStackSearchFunctions(store)?.children?.length == 0 ||
      JSON.stringify(obj) === "{}"
    ) {
      return {};
    } else {
      if (!this.changeView) {
        this.traverse_update_node(obj);
        this.addValueField(obj);
      } else {
        this.addValueField(obj);
      }

      return obj;
    }
  }
  public check_view_memory() {
    this.changeViewMemory = !this.changeViewMemory;
    if (this.type == "memory") {
      this.$nextTick(() => {
        this.renderFlame("#chart", this.perfettoStackSearch);
      });
    } else {
      this.$nextTick(() => {
        this.renderFlameXcode("#chart", this.perfettoStackXcode);
      });
    }
  }
  public funcSoTrend = [];
  public funcSoTrend_data() {
    let list = readGetPerfettoSoList(store);
    this.funcSoTrend = list.map((item) => {
      return item.replace(/\+/g, "");
    });

    return this.funcSoTrend;
  }
  public addValueField(data) {
    if (data) {
      if (data?.functionName == "root") {
        data.value = data?.self;
        data.name =
          data?.functionName +
          " " +
          (data?.self / 1024 / 1024).toFixed(2) +
          "MB";
      } else {
        data.value = data?.self;
        data.name = data?.functionName;
      }

      if (Array.isArray(data.children)) {
        data.children.forEach((child) => {
          this.addValueField(child);
        });
      }
    }
  }
  public traverse_update_node_xcode(node) {
    if (!node.children || node.children.length === 0) {
      return { Count: node.Count, MallocSize: node.MallocSize };
    } else {
      let Count_total = 0;
      let MallocSize_total = 0;
      for (let child of node.children) {
        let {
          Count: child_Count,
          MallocSize: child_Malloc,
        } = this.traverse_update_node_xcode(child);
        Count_total += child_Count;
        MallocSize_total += child_Malloc;
      }
      node.Count = Count_total;
      node.MallocSize = MallocSize_total;
      console.log({ Count: Count_total, MallocSize: MallocSize_total });
      return { Count: Count_total, MallocSize: MallocSize_total };
    }
  }
  public traverse_update_node(node) {
    if (!node.children || node.children.length === 0) {
      return { self: node.self, total: node.total };
    } else {
      let self_total = 0;
      let total_total = 0;
      for (let child of node.children) {
        let {
          self: child_self,
          total: child_total,
        } = this.traverse_update_node(child);
        self_total += child_self;
        total_total += child_total;
      }

      node.self = self_total;
      node.total = total_total;
      return { self: self_total, total: total_total };
    }
  }
  public check_view() {
    this.changeView = !this.changeView;
    this.$nextTick(() => {
      this.renderFlame_functions(
        "#chart_funcitons",
        this.perfettoStack_functions
      );
    });
  }
  public is_all: any = "";
  public dimension: any = "";
  public option_memory: any = "";
  public async mounted() {
    this.flameLoading = true;
    this.localProject = this.$route.query.project;
    this.type = this.$route.query.type;

    this.scene = this.$route.query.scene_name;
    this.level = decodeURIComponent(this.$route.query.level as any);
    this.old_date_name = this.$route.query.old_date_name;
    //   this.funcList=this.$route.query.func
    this.date = this.$route.query.date;
    this.version = this.$route.query.version;
    this.report_type = this.$route.query.report_type;
    this.device_id = this.$route.query.device_id;

    this.is_all = this.$route.query.is_all;
    // await dispatchPerfettoReport(store, {
    //   project: this.localProject,
    //   date: this.date,
    //   version: this.version,
    //   device_id: this.device_id,
    //   report_type: this.report_type,
    //   is_all:this.is_all
    // });

    if (this.type == "func") {
      this.funcList = this.$route.query.func;
      this.changeView = JSON.parse(this.$route.query.check as any);
      await dispatchPerfettoStackSearchFuncitons(store, {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        func: this.funcList,
      });
      this.$nextTick(() => {
        this.renderFlame_functions(
          "#chart_funcitons",
          this.perfettoStack_functions
        );
      });
    }
    if (this.type == "so") {
      await dispatchPerfettoReport(store, {
        project: this.localProject,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        is_all: this.is_all,
      });
      //    this.so=(this.$route.query.so as any).split(',')
      if (typeof this.$route.query.so === "string") {
        this.so = this.$route.query.so
          ? (this.$route.query.so as any).split(",")
          : [];
      } else {
        this.so = this.$route.query.so;
      }
      this.so_list_data_store();
      console.log(this.so);
      this.changeViewSo = JSON.parse(this.$route.query.check as any);
      await dispatchPerfettoStackSearchSo(store, {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        so: this.so,
      });
      this.$nextTick(() => {
        this.renderFlame_so("#chart_so", this.perfettoStack_so);
      });
    }
    if (this.type == "memory") {
      this.funcList = this.$route.query.func;
      if (typeof this.$route.query.so === "string") {
        this.so_list = this.$route.query.so
          ? (this.$route.query.so as any).split(",")
          : [];
      } else {
        this.so_list = this.$route.query.so;
      }

      console.log(this.so_list);
      this.size = this.$route.query.size;
      this.changeViewMemory = JSON.parse(this.$route.query.check as any);
      await dispatchPerfettoSoList(store, {
        project: this.localProject,
        level: this.level,
        device_id: Number(this.device_id),
        date: this.date,
        version: this.version,
        scene_id: this.scene,
        report_type: this.report_type,
        is_all: this.is_all,
      });
      this.funcSoTrend_data();
      await dispatchPerfettoStackSearch(store, {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        size: this.size,
        so: this.so_list.join(";"),
        func: this.funcList,
      });

      this.$nextTick(() => {
        this.renderFlame("#chart", this.perfettoStackSearch);
        this.flameLoading = false;
      });
    }
    if (this.type == "memory_xcode") {
      this.funcList = this.$route.query.func;
      this.dimension = this.$route.query.dimension;
      this.option_memory = this.$route.query.option;
      if (typeof this.$route.query.so === "string") {
        this.so_list = this.$route.query.so
          ? (this.$route.query.so as any).split(",")
          : [];
      } else {
        this.so_list = this.$route.query.so;
      }

      this.size = this.$route.query.size;
      this.changeViewMemory = JSON.parse(this.$route.query.check as any);
      let funcSoTrend = await dispatchXcodeSoList(store, {
        project: this.localProject,
        level: this.level,
        device_id: Number(this.device_id),
        date: this.date,
        version: this.version,
        scene_name: this.scene,
        report_type: this.report_type,
        type: this.is_all,
        dimension: this.dimension,
      });
      this.funcSoTrend = funcSoTrend.map((item) => {
        return item.replace(/\+/g, "");
      });
      await dispatchXcodeStack(store, {
        project: this.localProject,
        level: this.level,
        date: this.date,
        version: this.version,
        device_id: this.device_id,
        report_type: this.report_type,
        scene_name: this.scene,
        size: this.size,
        so: this.so_list.join(";"),
        func: this.funcList,
        type: this.is_all,
        dimension: this.dimension,
        option: this.option_memory,
      });

      this.$nextTick(() => {
        this.renderFlameXcode("#chart", this.perfettoStackXcode);
        this.flameLoading = false;
      });
    }
    if (this.type == "merge") {
      this.stack_v2_api();
    }
    if (this.type == 'ios-merge') {
      const {size, func, so, dimension_so} = this.$route.query

      this.size = size
      this.so_list = so ? so : []
      this.funcList = func
      this.ios_stack_v2_api()

      let funcSoTrend = await dispatchXcodeSoList(store, {
        project: this.localProject,
        level: this.level,
        device_id: Number(this.device_id),
        date: this.date,
        version: this.version,
        scene_name: this.scene,
        report_type: this.report_type,
        type: this.is_all,
        dimension: dimension_so,
      });
      this.funcSoTrend = funcSoTrend.map((item) => {
        return item.replace(/\+/g, "");
      });
    }
  }
  public renderFlame(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("chart");
    console.log(container);
    const containerWidth = container.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth - 20)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTime(d, originalColor, colorMapper)
      ) // 传递 colorMapper 参数
      .inverted(true);
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    // .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public labelTimeXcode = (d, data) => {
    //  "(" +
    //   (d.parent == null
    //     ? "100%"
    //     : ((d.value / (data as any).value) * 100).toFixed(2) +
    //       "%") +

    //   ")"
    // return `<div><div style="font-size:14px">${d.data.name}</div><div>${d.data.value}</div><div>soName:${d.data.soName}</div></div>`
    // console.log(d)
    return (
      d.data.name +
      "\nLibraryName:" +
      d.data.LibraryName +
      "\nMallocSize:" +
      this.sizeCompany(d.data.value) +
      "\nCount:" +
      d.data.Count +
      "\nTotalMallocSize:" +
      this.sizeCompany(d.data.TotalMallocSize)
    );
  };
  public sizeCompany(item) {
    if (String(item) != "") {
      if (Number(item) < 1024) {
        return String(item) + "K";
      }
      if (Number(item) > 1024) {
        return (Number(item) / 1024).toFixed(1) + "M";
      }
    } else {
      return "";
    }
  }
  public flameLoading = false;
  public renderFlameXcode(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("chart");
    console.log(container);
    const containerWidth = container.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth - 20)
      .label((d) => this.labelTimeXcode(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTimeXcode(d, originalColor, colorMapper)
      ) // 传递 colorMapper 参数
      .inverted(true);
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    // .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public labelWallTime_v2 = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (!this.funcList && this.so_list.length == 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      if (this.funcList) {
        let list = this.funcList.split(",");
        // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
        const hasMatchingKeyword = list.some((v) => {
          return (
            d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1
          );
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
      if (this.so_list.length > 0) {
        const hasMatchingKeyword = this.so_list.some((v) => {
          return d.data.soName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
    }
  };
  public labelWallTime = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (!this.funcList && this.so_list.length == 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      if (this.funcList) {
        let list = this.funcList.split(",");
        // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
        const hasMatchingKeyword = list.some((v) => {
          return (
            d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1
          );
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
      if (this.so_list.length > 0) {
        const hasMatchingKeyword = this.so_list.some((v) => {
          return d.data.soName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
    }
  };
  public labelWallTimeXcode = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (!this.funcList && this.so_list.length == 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      if (this.funcList) {
        let list = this.funcList.split(",");
        // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
        const hasMatchingKeyword = list.some((v) => {
          return d.data.Name.toUpperCase().indexOf(v.toUpperCase()) !== -1;
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
      if (this.so_list.length > 0) {
        const hasMatchingKeyword = this.so_list.some((v) => {
          return (
            d.data.LibraryName.toUpperCase().indexOf(v.toUpperCase()) !== -1
          );
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
    }
  };
  public get perfettoStack_so() {
    let obj = JSON.parse(JSON.stringify(readGetPerfettoStackSearchSo(store)));
    if (
      readGetPerfettoStackSearchSo(store)?.children?.length == 0 ||
      JSON.stringify(obj) === "{}"
    ) {
      return {};
    } else {
      if (!this.changeViewSo) {
        this.traverse_update_node(obj);
        this.addValueField(obj);
      } else {
        this.addValueField(obj);
      }

      return obj;
    }
  }
  public get perfettoStackSearch() {
    let obj = JSON.parse(JSON.stringify(readGetPerfettoStackSearch(store)));
    if (
      readGetPerfettoStackSearch(store)?.children?.length == 0 ||
      JSON.stringify(obj) === "{}"
    ) {
      return {};
    } else {
      if (!this.changeViewMemory) {
        this.traverse_update_node(obj);
        this.addValueField(obj);
      } else {
        this.addValueField(obj);
      }

      return obj;
    }
  }
  public addXcodeValueField(data) {
    if (data) {
      if (data?.Name == "root") {
        data.value = data?.MallocSize;
        data.name =
          data?.Name + " " + (data?.MallocSize / 1024).toFixed(2) + "MB";
      } else {
        data.value = data?.MallocSize;
        data.name = data?.Name;
      }

      if (Array.isArray(data.children)) {
        data.children.forEach((child) => {
          this.addXcodeValueField(child);
        });
      }
    }
  }
  public get perfettoStackXcode() {
    let obj = JSON.parse(JSON.stringify(readGetXcodeStack(store)));
    if (
      readGetXcodeStack(store)?.children?.length == 0 ||
      JSON.stringify(obj) === "{}"
    ) {
      return {};
    } else {
      if (!this.changeViewMemory) {
        this.traverse_update_node_xcode(obj);
        this.addXcodeValueField(obj);
      } else {
        this.addXcodeValueField(obj);
      }

      return obj;
    }
  }
  public renderFlame_so(selector, data) {
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);
    const container = document.getElementById("chart_so");
    console.log(container);
    const containerWidth = container.clientWidth;
    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth - 20)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTime_so(d, originalColor, colorMapper)
      ) // 传递 colorMapper 参数
      .inverted(true);
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    // .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public labelWallTime_so = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    console.log(this.so);
    console.log(5555);
    if (this.so.length == 0) {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      console.log(this.so);
      let list = this.so;
      // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
      const hasMatchingKeyword = list.some((v) => {
        return d.data.soName.toUpperCase().indexOf(v.toUpperCase()) !== -1;
      });

      // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
      return hasMatchingKeyword ? "#f00" : color;
    }
  };
  public labelTime = (d, data) => {
    //  "(" +
    //   (d.parent == null
    //     ? "100%"
    //     : ((d.value / (data as any).value) * 100).toFixed(2) +
    //       "%") +

    //   ")"
    // return `<div><div style="font-size:14px">${d.data.name}</div><div>${d.data.value}</div><div>soName:${d.data.soName}</div></div>`
    return (
      d.data.name +
      "\nsoName:" +
      d.data.soName +
      "\nself:" +
      this.getNum(d.data.value) +
      (d.data.self_diff ? this.diffNum(d.data.self_diff) : "") +
      "\ntotal:" +
      this.getNum(d.data.total) +
      (d.data.self_diff ? this.diffNum(d.data.total_diff) : "")
    );
  };
  public getNum(num) {
    if (num >= 1024 * 1024) {
      return (num / 1024 / 1024).toFixed(2) + "MB";
    } else if (num >= 1024 && num < 1024 * 1024) {
      return (num / 1024).toFixed(2) + "KB";
    } else if (num < 1024) {
      return num.toFixed(2) + "B";
    }
  }
  public diffNum(num) {
    let diff = Math.abs(num);
    let data = this.getNum(diff);
    if (num < 0) {
      return "(-" + data + ")";
    } else {
      return "(+" + data + ")";
    }
  }
  public renderFlame_functions(selector, data) {
    const container = document.getElementById("chart_funcitons");
    console.log(container);
    const containerWidth = container.clientWidth;
    let flame: any = flamegraph();
    function getAllValues(node) {
      const values = [node.value];
      if (Array.isArray(node.children)) {
        node.children.forEach((child) => {
          values.push(...getAllValues(child));
        });
      }
      return values;
    }

    // 获取火焰图数据中的最大值
    const allValues = getAllValues(data);
    const maxDataValue = d3.max(allValues);

    // 创建颜色映射器
    const colorMapper = d3
      .scaleLinear()
      .domain([0, maxDataValue * 0.5, maxDataValue])
      .range(["#B6EBCF  ", "#FEBEBE", "#DAC4FF"]);
    flame
      .width(containerWidth - 20)
      .label((d) => this.labelTime(d, data))
      // .tooltip({ show: this.customTooltip })
      .transitionDuration(1000)
      // .color((d) => colorMapper(d.data.value)) // 使用自定义颜色映射器
      .setColorMapper((d, originalColor) =>
        this.labelWallTime_functions(d, originalColor, colorMapper)
      ) // 传递 colorMapper 参数
      .inverted(true);
    // .onHover((node, el) => this.handleHover(node, el)); // 添加 onHover 方法

    // .inverted(true);

    // flame.onHover((node) => {
    //   this.func_name = node.data.name;
    //   this.func_rate = node.data.rate + "%";
    // });

    d3.select(selector).datum(data).call(flame);
    // d3.select(selector).style("background-color", "#333");
  }
  public labelWallTime_functions = (d, originalColor, colorMapper) => {
    // 使用 colorMapper 计算颜色
    const color = colorMapper(d.data.value);

    // 如果没有输入，直接返回计算出的颜色
    if (this.funcList === "") {
      return color;
    } else {
      // 如果输入存在，根据输入内容判断是否需要修改颜色
      if (this.funcList) {
        let list = this.funcList.split(",");
        // 变为数组 主要目的是内置方法直接字符串indexof!=-1 会bug 底层是0判断 但是判断不全
        const hasMatchingKeyword = list.some((v) => {
          return (
            d.data.functionName.toUpperCase().indexOf(v.toUpperCase()) !== -1
          );
        });

        // 如果有匹配的关键词，返回 "#f00"，否则返回原始颜色
        return hasMatchingKeyword ? "#f00" : color;
      }
    }
  };
}
